'use client';
import { useEffect } from 'react';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import ServiceCycleInfographic from './components/ServiceCycleInfographic';
import DeliverablesGrid from './components/DeliverablesGrid';
import Link from 'next/link';

export default function SocialMediaPlansPage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal');
    if (!reveals?.length) return;

    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    );
    reveals?.forEach((el) => observer?.observe(el));

    return () => observer?.disconnect();
  }, []);

  return (
    <>
      <Header />
      <main className="pt-32">
        {/* Page Header */}
        <section className="pb-20 bg-background">
          <div className="max-w-5xl mx-auto px-6 text-center reveal">
            <div className="flex items-center justify-center gap-4 mb-6">
              <div className="w-[2px] h-4 bg-gradient-to-b from-pink-500 to-purple-600" />
              <span className="text-[10px] uppercase tracking-[0.3em] font-bold text-zinc-400">
                Complete Social Media Solutions
              </span>
            </div>
            <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold tracking-tight mb-8 text-white">
              Social Media Plans<br />
              <span className="bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
                Everything You Need
              </span>
            </h1>
            <p className="text-lg md:text-xl text-zinc-400 max-w-3xl mx-auto leading-relaxed">
              From onboarding to customer acquisition, we provide comprehensive social media management that repeats every month. Get reels, posters, profile handling, paid ads, and so much more.
            </p>
          </div>
        </section>

        <ServiceCycleInfographic />
        <DeliverablesGrid />

        {/* CTA Section */}
        <section className="py-20 md:py-32 bg-background">
          <div className="max-w-4xl mx-auto px-6 text-center reveal">
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6 text-white">
              Ready to Transform Your Social Media?
            </h2>
            <p className="text-lg text-zinc-400 mb-8 max-w-2xl mx-auto">
              Let's create a custom social media plan that drives real results for your business.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                href="/contact"
                className="px-8 py-4 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-xl hover:shadow-lg hover:shadow-pink-500/50 transition-all font-semibold"
              >
                Get Your Custom Plan
              </Link>
              <Link
                href="/services"
                className="px-8 py-4 border border-zinc-700 text-white rounded-xl hover:bg-zinc-800 transition-all font-semibold"
              >
                View All Services
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}